/** Etiqueta legible para `ambiente` en perfiles CAF / DTE (SII). */
export function labelAmbienteSii(raw) {
  const a = String(raw ?? "").trim().toLowerCase();
  if (a === "certificacion") return "Certificación";
  if (a === "produccion") return "Producción";
  return raw ? String(raw) : "";
}
